/* eslint-disable no-undef, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-call */
import Cookies from 'js-cookie';
import registry from '~/library/store/src/registry';
import { GET_CORE_CONFIG } from './actions';

export const coreState = {
  isLoggedIn: false,
  isLoading: false,
  experiments: []
};

const updatePartnerCookies = partnerObj => {
  Cookies.set('PartnerObject', JSON.stringify(partnerObj));
  Cookies.set('PartnerAssetUrl', partnerObj.partnerAssetUrl);
  Cookies.set('PartnerLongName', partnerObj.partnerLongName);
  Cookies.set('PartnerVanityUrlName', partnerObj.partnerVanityUrlName);
};

export default function reducer(state = coreState, action = {}) {
  const { type, payload } = action;
  const partnerString = Cookies.get('PartnerObject');
  let partnerObj = {};

  const defaultPartnerObj = {
    partnerAssetUrl: `${process.env.CDN_URL}/partner-header-logos-assets/notused.png`,
    isExtendedWarrantyOffered: true,
    partnerDirectPhoneNumber: '1.800.333.4554',
    partnerHomePageUrl: 'https://www.carvana.com/',
    partnerId: 1,
    partnerInstitutionLoanCalcUrl: null,
    partnerKey: 'Carvana',
    partnerLoanApplicationUrl: 'https://www.carvana.com/',
    partnerLongName: 'Carvana',
    partnerShortName: 'Carvana',
    partnerVanityUrlName: 'notused',
    partnerWhisperNumber: '1.800.333.4554',
    shouldHidePartnerHeaderBanner: true
  };

  if (partnerString !== undefined && partnerString !== '') {
    try {
      const parsed = JSON.parse(partnerString);

      if (
        parsed &&
        typeof parsed === 'object' &&
        parsed.partnerId &&
        parsed.partnerKey &&
        partnerString.trim().endsWith('}')
      ) {
        partnerObj = parsed;
      } else {
        console.warn('Partner object is malformed or incomplete, using Carvana default', parsed);
        partnerObj = defaultPartnerObj;
        updatePartnerCookies(defaultPartnerObj);
      }
    } catch (error) {
      console.warn('Failed to parse partner object, using Carvana default', error);
      partnerObj = defaultPartnerObj;
      updatePartnerCookies(defaultPartnerObj);
    }
  }

  switch (type) {
    case '@@EXPERIMENT_USER_BUCKETED':
      return {
        ...state,
        experiments: payload?.experiments
      };

    case `${GET_CORE_CONFIG}_LOADING`:
      return {
        ...state,
        isLoading: true
      };

    case `${GET_CORE_CONFIG}_SUCCESS`:
      return {
        ...state,
        phoneNumber: partnerObj?.partnerDirectPhoneNumber?.replace(/\./g, '-'),
        isLoggedIn: payload?.hasProfile,
        isUserBeingImpersonated: payload?.isUserBeingImpersonated,
        userId: payload?.userId,
        email: payload?.email,
        name: payload?.name,
        isLoading: false
      };

    case `${GET_CORE_CONFIG}_ERROR`:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: payload
      };

    default:
      return state;
  }
}

registry.register('core', reducer, coreState);
